/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_TitleInputs */

const en_admin_settings_title = /** @type {(inputs: Admin_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Settings`)
};

const zh_admin_settings_title = /** @type {(inputs: Admin_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统设置`)
};

/**
* | output |
* | --- |
* | "System Settings" |
*
* @param {Admin_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_title = /** @type {((inputs?: Admin_Settings_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_title(inputs)
	return zh_admin_settings_title(inputs)
});
export { admin_settings_title as "admin.settings.title" }